<!--
 * @Date: 2020-08-13 09:35:27
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-08-14 11:24:46
 * @FilePath: \pc-mall\src\views\payFailed.vue
-->
<template>
  <div class="pay-result">
    <div class="content">
      <p class="text1">非常抱歉，支付未成功！</p>
      <p class="text2">支付异常，该订单已为您保留到"待支付"订单中，请尝试重新支付</p>
      <img src="../assets/images/payfail.png" />
      <p class="button">
        <span @click="handleToPay()">重新支付</span>
        <span class="red-btn" @click="toOrder()">查看订单</span>
      </p>
    </div>
    <!-- 支付弹框 -->
    <payDialog ref="payDialog" :from="from" />
  </div>
</template>

<script>
import PayDialog from '@/components/payDialog'
export default {
  data () {
    return {
      orderNo: null,
      from: null
    }
  },
  components: {
    'payDialog': PayDialog
  },
  created () {
    this.orderNo = this.$route.query.orderNo
    this.moduleType = this.$route.query.moduleType || 'TRIP'
    this.from = this.$route.query.from
  },
  methods: {
    handleToPay () {
      this.$refs.payDialog.toPay(this.orderNo, this.moduleType)
    },
    toOrder () {
      this.$router.push({ path: 'personalCenter', query: { moduleType: this.moduleType } })
    }
  }
}
</script>
